import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { getTikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/adapter'
import { TikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/interfaces'
import { NAMESPACE } from 'apps/tiktokFollowWelcome/store/constants'
import { tiktokApi } from 'shared/api/requests/tiktok'
import { createAsyncAction } from 'shared/lib/redux'

export const removeTikTokFlow = createAsyncAction(`${NAMESPACE}/removeFlow`, async () => {
  const removedFlowData = await tiktokApi.tikTokFollowReply.removeFlow()

  return removedFlowData.data
})

export const removeTikTokFlowReducer = (
  builder: ActionReducerMapBuilder<TikTokFollowWelcomeState>,
) => {
  builder.addCase(removeTikTokFlow.fulfilled, (state, action) => ({
    ...state,
    ...getTikTokFollowWelcomeState(action.payload),
  }))
}
